import { useParams } from 'react-router-dom'

import { CampaignStatusEnum } from 'src/Types/campaigns'

import {
  SpotifyCampaignTrack,
  SpotifyCampaignType,
  useGetSpotifyCampaignStatusQuery,
} from '../spotifyCampaignStatusApi'

interface CampaignDetails {
  matchingType?: string | null
  Track?: SpotifyCampaignTrack
  budget?: number
  end_date?: string | null
  id?: number
  isPreRelease?: boolean
  releaseDate?: string | null
  playlists_adds?: number
  refund?: number
  reviewed_count?: number
  reviews_count?: number
  start_date?: string | null
  status?: CampaignStatusEnum
  type?: SpotifyCampaignType
  spent?: number
  trackActiveCampaignsCount?: number
  metadata?: {
    minCuratorsCount: number
    maxCuratorsCount: number
    maxPlaylistsCount: number
  }
}

type SpotifyCampaignDetails = {
  campaignDetails: CampaignDetails | undefined
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}

export const useSpotifyCampaignDetails = (): SpotifyCampaignDetails => {
  const { campaignID } = useParams<{ campaignID: string }>()
  const { data, ...restData } = useGetSpotifyCampaignStatusQuery(
    Number(campaignID),
    { refetchOnMountOrArgChange: true },
  )

  return {
    campaignDetails: {
      id: data?.id,
      status: data?.status,
      type: data?.type,
      spent: data?.spent,
      start_date: data?.startDate,
      end_date: data?.endDate,
      trackActiveCampaignsCount: data?.trackActiveCampaignsCount,
      metadata: {
        minCuratorsCount: data?.metadata?.minCuratorsCount || 0,
        maxCuratorsCount: data?.metadata?.maxCuratorsCount || 0,
        maxPlaylistsCount: data?.metadata?.maxPlaylistsCount || 0,
      },
      budget: data?.amount,
      refund: data?.refund,
      reviewed_count: data?.reviewedCount,
      reviews_count: data?.reviewedCount,
      playlists_adds: data?.playlistsAdds,
      isPreRelease: data?.isPreRelease,
      releaseDate: data?.releaseDate,
      Track: data?.track,
      matchingType: data?.matchingType,
    },
    ...restData,
  }
}
